import React from 'react';
import { OnboardingStepGate } from '../../components/OnboardingStepGate';
import { ROUTES_PATH } from '../../constants/Routes';
import { useOnboardingOffice } from './useOnboardingOffice';

interface OnboardingOfficeGateProps {
  children: React.ReactNode;
  isExempt?: boolean;
}

export function OnboardingOfficeGate({ children, isExempt }: OnboardingOfficeGateProps) {
  const { status, isPollingCredits, oabSkipped } = useOnboardingOffice();
  const stepPath = oabSkipped
    ? ROUTES_PATH.ONBOARDING.PHOTO
    : ROUTES_PATH.ONBOARDING.OFFICE;

  return (
    <OnboardingStepGate
      status={status}
      stepPath={stepPath}
      isPollingCredits={isPollingCredits}
      isExempt={isExempt}
    >
      {children}
    </OnboardingStepGate>
  );
}
